import React, { useEffect } from "react";
import { X, ExternalLink } from "lucide-react";

const CalendlyModal = ({ open, onClose, url }) => {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  const safeUrl = url && /^https?:\/\//.test(url) ? url : "";

  return (
    <div
      data-testid="calendly-modal"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
    >
      <div
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
        data-testid="calendly-backdrop"
      />
      <div className="relative w-full max-w-4xl h-[80vh] em-card overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-[#e8e2cf]">
          <div>
            <div className="font-mono-em text-[10px] tracking-[0.25em] uppercase text-[#8a6a10]">
              Book a Diagnostic
            </div>
            <div className="text-[#0a0a0a] font-display text-lg mt-0.5">
              Schedule your GrowthOS™ session
            </div>
          </div>
          <div className="flex items-center gap-2">
            {safeUrl && (
              <a
                href={safeUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="calendly-open-external"
                className="btn-ghost text-xs"
              >
                Open <ExternalLink size={14} />
              </a>
            )}
            <button
              data-testid="calendly-close"
              aria-label="Close"
              onClick={onClose}
              className="w-9 h-9 rounded-full flex items-center justify-center text-[#6b6356] hover:text-[#8a6a10] hover:bg-[#d4af37]/15 transition"
            >
              <X size={18} />
            </button>
          </div>
        </div>
        <div className="flex-1 bg-white">
          {safeUrl ? (
            <iframe
              data-testid="calendly-iframe"
              title="Calendly"
              src={safeUrl}
              className="w-full h-full border-0"
            />
          ) : (
            <div className="h-full flex items-center justify-center text-[#6b6356] p-8 text-center bg-white">
              Calendly link not configured yet. Please add a CALENDLY_URL to the
              backend .env file.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendlyModal;
